import { connect, mapProps } from '@formily/react'
import { Checkbox as UICheckbox } from '@/components/ui/checkbox'
import type { CheckboxProps as UICheckboxProps } from '@radix-ui/react-checkbox'
import { useMemo } from 'react'

export interface FormilyCheckboxProps {
  value?: any[]
  onChange?: (checked: any[]) => void
  className?: string
  disabled?: boolean
  options?: {
    label: string
    value: string
  }[]
}

const InternalCheckbox = ({
  value,
  onChange,
  options,
  ...props
}: FormilyCheckboxProps) => {
  const localValue = useMemo(() => {
    return Array.isArray(value) ? value : []
  }, [value])

  return (
    <div className="flex flex-row flex-wrap gap-2 justify-start items-center">
      {options?.map((option) => (
        <div
          className="flex flex-row items-center space-x-2"
          key={option.value}
        >
          <UICheckbox
            value={option.value}
            checked={localValue?.includes(option.value)}
            onCheckedChange={(checked) => {
              return checked
                ? onChange?.([...localValue, option.value])
                : onChange?.(
                    localValue?.filter((value) => value !== option.value),
                  )
            }}
          />
          <span>{option.label}</span>
        </div>
      ))}
    </div>
  )
}

export const FormilyCheckbox = connect(
  InternalCheckbox,
  mapProps({
    dataSource: 'options',
  }),
)
